import HttpCliente from "../HttpCliente";

export const getClasificacionDocumentos = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/ClasificacionDocumento/ObtenerClasificaciones", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postClasificacionDocumentos = (token, clasificacion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/ClasificacionDocumento/Crear", clasificacion, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error en la petición:", error);
      reject(error);
    });
  });
};

  export const putClasificacionDocumentos = (token, clasificacion) => {
    return new Promise((resolve, reject) => {
      HttpCliente.put("/ClasificacionDocumento/EditarClasificacion", clasificacion, {
        headers: {
          "Authorization": `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

export const deleteClasificacionDocumentos = (token, id) => {
    return new Promise((resolve, reject) => {
      HttpCliente.delete(`/ClasificacionDocumento/Deshabilitar/${id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
          'accept': 'text/plain'
        }
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

export const getClasificacionDocumentoHabilitado = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/ClasificacionDocumento/ObtenerClasificacionHabilitado", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};